import HTTPResponseEntity     from '@/js/Shared/Services/HTTP/Entities/HTTPResponseEntity.js';
import OutOfOfficeOptionsItem from '../Collections/OutOfOfficeOptionsItem.js';

export { OutOfOfficeHTTPMapping as default };

/**
* Out of office HTTP Mapping
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class OutOfOfficeHTTPMapping {
  /**
   * Maps out of office options http results into an option entity
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {OutOfOfficeOptionsItem} options  options item entity
   * @param {HTTPResponseEntity}     response http response entity
   *
   * @return {void}
   */
  map(options, response) {
    if (!response.results) {
        return;
      }

      options.enabled    = response.results.oofActivate === 'on' ? true : false;
      options.date_start = response.results.oofStartDate;
      options.date_end   = response.results.oofEndDate;
      options.message    = response.results.oofMsg;
  }
}